import React from 'react';
import { myTheme } from '../assets/styles/my-theme';
import { Icon, mergeStyleSets, TooltipHost } from '@fluentui/react';

const { palette } = myTheme;

const classNames = mergeStyleSets({
    iconField: {
        padding: '5px',
        width: '28px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    }
});


export interface TableIconCopiaConoscenzaProps {
}

const TableIconCopiaConoscenza: React.FunctionComponent<TableIconCopiaConoscenzaProps> = (props) => {
    return (
        <div className={classNames.iconField} >
            <TooltipHost content="Copia Conoscenza" id={"tooltipCopiaConoscenza"}>
                <Icon iconName="Accounts" style={{ fontSize: 16, color: palette.themePrimary }} />
            </TooltipHost>
        </div>
    );
}
export default TableIconCopiaConoscenza;